import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeftSmall = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.71,12.29c0.39,0.39,0.39,1.02,0,1.41c-0.39,0.39-1.02,0.39-1.41,0l-5-5c-0.39-0.39-0.39-1.02,0-1.41l5-5c0.39-0.39,1.02-0.39,1.41,0c0.39,0.39,0.39,1.02,0,1.41L6.41,8L10.71,12.29z",
		fill: "currentColor"
	})
});
export default SvgArrowLeftSmall;
